import { Button, Modal, ModalBody } from "@ht/components";
import clsx from "clsx";
import { FC } from "react";
interface IProps {
    visible: boolean;
    onClose: () => void;
    onDownload: () => void;
    onClosedCaption?: () => void;
    viewerBody: JSX.Element;
    attachmentType: string;
}
export const PreviewerModal: FC<IProps> = ({ visible, onClose, onDownload, viewerBody, onClosedCaption, attachmentType }) => {
    return (<Modal centered className="!overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 " size="auto"
        show={visible} onClose={onClose}>
        <ModalBody>
            <Button className={clsx({
                "bg-primary border-none ml-1 absolute right-8 top-0 m-2 z-10": true,
                "!rounded-l-lg": (attachmentType != "VIDEO_RECORDINGX" && attachmentType != "VOICE_RECORDINGX")
            })} onClick={onDownload}>
                <span className="fa fa-download"></span>
            </Button>
            {(attachmentType == "VIDEO_RECORDINGX" || attachmentType == "VOICE_RECORDINGX") &&
                <Button className="h-[31px] bg-primary border-none ml-1  rounded-l-lg absolute right-16 top-0 m-2 z-10"
                    onClick={onClosedCaption}>
                    CC
                </Button>
            }
            <Button onClick={onClose} color="secondary"
                className="border-none ml-1  rounded-r-lg absolute right-0 top-0 m-2 z-10">
                <span className="fa fa-times"></span>
            </Button>
            <div className="overflow-auto max-h-[85vh] rounded-lg scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {viewerBody}
            </div>
        </ModalBody>
    </Modal >);
}